import React, { useState } from 'react';

import { Box } from '@mui/material';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import { globalTheme } from '../../../../../../shared/theme/theme';
import { ReviewStatisticsModel } from '../../models/review-statistics.model';
import { CustomYAxisTick } from '../../shared/components/custom-y-axis-tick/custom-y-axis-tick';
import { StatsFallbackComponent } from '../stats-fallback-component/stats-fallback-component';
import { CustomTooltipRatingsChart } from './components/custom-tooltip-ratings-chart';

export const RatingsBreakdownChart = ({
  stats,
}: {
  stats: ReviewStatisticsModel | null;
}) => {
  const [activeBarIndex, setActiveBarIndex] = useState<number | undefined>(
    undefined
  );

  return (
    <Box sx={{ ml: '-24px' }}>
      <ResponsiveContainer width="100%" height={253}>
        {stats && stats.ratingBreakdown.length > 0 ? (
          <BarChart
            layout="vertical"
            data={stats?.ratingBreakdown.slice().reverse()}
            barCategoryGap="30%"
          >
            <CartesianGrid horizontal={false} />
            <XAxis type="number" style={{ fontSize: '12px' }} />
            <YAxis
              type="category"
              dataKey="rating"
              tick={<CustomYAxisTick />}
              axisLine={false}
              tickLine={false}
            />
            <Tooltip
              content={<CustomTooltipRatingsChart />}
              cursor={false}
              wrapperStyle={{
                border: 'none',
                boxShadow: 'none',
                outline: 'none',
              }}
            />
            <Bar
              dataKey="totalNrOfRatings"
              fill={globalTheme.palette.primary.main}
            >
              {stats?.ratingBreakdown.map((_, index) => {
                const isHovered = index === activeBarIndex;
                return (
                  <Cell
                    key={`cell-${index}`}
                    onMouseEnter={() => setActiveBarIndex(index)}
                    onMouseLeave={() => setActiveBarIndex(undefined)}
                    fill={
                      isHovered
                        ? globalTheme.palette.primary.dark
                        : globalTheme.palette.primary.main
                    }
                  />
                );
              })}
            </Bar>
          </BarChart>
        ) : (
          <StatsFallbackComponent />
        )}
      </ResponsiveContainer>
    </Box>
  );
};
